import React from 'react';
import { FormData } from '../types';
import StepCard from './StepCard';
import TextEditor from './TextEditor';
import ImageUpload from './ImageUpload';
import ButtonInput from './ButtonInput';
import TelegramPreview from './TelegramPreview';

interface AdFormProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
}

const AdForm: React.FC<AdFormProps> = ({ formData, setFormData }) => {
  return (
    <div className="process-container">
      {/* Step 1: Write Ad - Required */}
      <StepCard 
        stepNumber="1️⃣" 
        title="Write your ad"
      >
        <TextEditor 
          formData={formData}
          setFormData={setFormData}
        />
      </StepCard>

      {/* Step 2: Add Image - Optional & Expandable */}
      <StepCard 
        stepNumber="2️⃣" 
        title="Add an image"
        isExpandable={true}
        isOptional={true}
        defaultExpanded={false}
      >
        <ImageUpload 
          formData={formData}
          setFormData={setFormData}
        />
      </StepCard>

      {/* Step 3: Add Button & Link - Optional & Expandable */}
      <StepCard 
        stepNumber="3️⃣" 
        title="Add button & link"
        isExpandable={true}
        isOptional={true}
        defaultExpanded={false}
      >
        <ButtonInput 
          formData={formData}
          setFormData={setFormData}
        />
      </StepCard>

      {/* Step 4: Preview - Always Visible */}
      <StepCard 
        stepNumber="4️⃣" 
        title="Preview your ad"
        subtitle="This is how it will appear on Neodia"
        isPreview={true}
      >
        <TelegramPreview 
          formData={formData}
        />
      </StepCard>
    </div>
  );
};

export default AdForm; 